<template>
  <!-- 内容区 -->
  <div class="news-detail portfolio-detail">
    <!-- banner -->
    <div class="banner-home banner-small">
      <div class="container">
        <img src="../assets/images/title-works.svg" class="banner-title" />
      </div>
    </div>
    <div class="container">
      <div class="content-box">
        <div class="portfolio-class">
          <img
            src="../assets/images/icon-class-1.svg"
            class="icon-class"
          />实践类
        </div>
        <div class="portfolio-title">
          001 河北省“保护个人信息 护航数据安全”网络主题教育活动
        </div>
        <div id="vidro-content" v-show="voteInfo.vid"></div>
        <div class="d-flex  row">
          <div class="portfolio-info">
            应用场景 电子商务
          </div>
        </div>
        <div class="content">
          <div class="title">
            <img
              src="../assets/images/title-shape.svg"
              class="icon-title-shape"
            />案例取得效果<img
              src="../assets/images/title-shape.svg"
              class="icon-title-shape"
            />
          </div>
          <p>
            随着信息技术和人类生产生活交汇融合，各类数据迅猛增长、海量聚集，对经济发展、人民生活都产生了重大而深刻的影响。数据安全已成为事关国家安全与经济社会发展的重大问题。党中央对此高度重视，就加强数据安全工作和促进数字化发展作出一系列部署。按照党中央决策部署和贯彻总体国家安全观的要求，全国人大常委会积极推动数据安全立法工作。
          </p>
          <div class="title">
            <img
              src="../assets/images/title-shape.svg"
              class="icon-title-shape"
            />案例主要情况<img
              src="../assets/images/title-shape.svg"
              class="icon-title-shape"
            />
          </div>
          <p>
            随着信息技术和人类生产生活交汇融合，各类数据迅猛增长、海量聚集，对经济发展、人民生活都产生了重大而深刻的影响。数据安全已成为事关国家安全与经济社会发展的重大问题。党中央对此高度重视，就加强数据安全工作和促进数字化发展作出一系列部署。按照党中央决策部署和贯彻总体国家安全观的要求，全国人大常委会积极推动数据安全立法工作。
          </p>
          <div class="title">
            <img
              src="../assets/images/title-shape.svg"
              class="icon-title-shape"
            />其他材料<img
              src="../assets/images/title-shape.svg"
              class="icon-title-shape"
            />
          </div>
          <p>
            随着信息技术和人类生产生活交汇融合，各类数据迅猛增长、海量聚集，对经济发展、人民生活都产生了重大而深刻的影响。数据安全已成为事关国家安全与经济社会发展的重大问题。党中央对此高度重视，就加强数据安全工作和促进数字化发展作出一系列部署。按照党中央决策部署和贯彻总体国家安全观的要求，全国人大常委会积极推动数据安全立法工作。
          </p>
          <p>
            随着信息技术和人类生产生活交汇融合，各类数据迅猛增长、海量聚集，对经济发展、人民生活都产生了重大而深刻的影响。数据安全已成为事关国家安全与经济社会发展的重大问题。党中央对此高度重视，就加强数据安全工作和促进数字化发展作出一系列部署。按照党中央决策部署和贯彻总体国家安全观的要求，全国人大常委会积极推动数据安全立法工作。
          </p>
        </div>

        <!-- <div class="like-wrap">
          <a class="icon-like" href="javascript:void(0)"></a>
          <span class="nums">78</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { voteDetail } from "@/network/API.js";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      voteInfo: {},
      player: null
    };
  },
  async created() {
    if (this.$route.params.id) {
      let info = await voteDetail(this.$route.params.id);
      info.intro = Base64.decode(info.intro);
      this.voteInfo = info;
      // this.voteInfo.vid = "e33086ydak8"
      if (this.voteInfo.vid) {
        this.playerInit(this.voteInfo.vid)
      }
    }
  },
  destroyed() {
    if (this.player) {
      this.player.destroy();
    }
  },
  methods: {
    playerInit(vid) {
      this.player = new Txplayer({
        containerId: "vidro-content",
        vid: vid,
        width: "100%",
        height: screen.availHeight / 3,
        autoplay: true
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/WorksDetail.vue